import { useCallback, useMemo, useState } from 'react';

export interface IPageFiltersState {
  productIds: string[],
  regionIds: string[],
}

export interface IUsePageFiltersState {
  state: IPageFiltersState,
  setPageFilters: (payload: Partial<IPageFiltersState>) => void,
}

const INITIAL_PAGE_FILTERS: IPageFiltersState = {
  productIds: [],
  regionIds: [],
};

const usePageFiltersState = (): IUsePageFiltersState => {
  const [state, setState] = useState<IPageFiltersState>(INITIAL_PAGE_FILTERS);

  const setPageFilters = useCallback((payload: Partial<IPageFiltersState>): void => {
    setState((prevState) => ({ ...prevState, ...payload }));
  }, []);

  return useMemo(() => ({ state, setPageFilters }), [state, setPageFilters]);
};

export default usePageFiltersState;
